<script lang="ts">
	import type { Snippet } from 'svelte';
	import { cn } from './cn';
	import { BUTTON_VARIANTS, type ButtonVariant } from './buttonVariants';

	/** An action the reader takes. For one that navigates, use ButtonLink. */
	let {
		variant = 'secondary',
		type = 'button',
		disabled = false,
		busy = false,
		pressed,
		title,
		label,
		onclick,
		class: extra,
		children
	}: {
		variant?: ButtonVariant;
		type?: 'button' | 'submit';
		disabled?: boolean;
		/** Work is running behind this button, so a screen reader says so too. */
		busy?: boolean;
		/** Makes this a toggle, and says which way it is set. */
		pressed?: boolean;
		title?: string;
		/** The accessible name, for a ghost button whose only content is an icon. */
		label?: string;
		onclick?: () => void;
		class?: string;
		children: Snippet;
	} = $props();
</script>

<button
	{type}
	{disabled}
	{title}
	{onclick}
	aria-label={label}
	aria-busy={busy ? 'true' : undefined}
	aria-pressed={pressed}
	class={cn(BUTTON_VARIANTS[variant], extra)}
>
	{@render children()}
</button>
